import type { Table } from '@tanstack/react-table'
import React from 'react'
import styled from 'styled-components'

import { HorizontalScrollWrapper } from './HorizontalScrollWrapper'

export interface NoVirtualizerProps<TData> {
  'data-e2e'?: string
  bottomOffset: number
  isWindowScrollable?: boolean
  table: Table<TData>
  horizontalScrollingArea: HTMLDivElement | null
  setHorizontalScrollingAreaRef: (node: HTMLDivElement | null) => void
  children: React.ReactNode
}

export const HorizontalScrollingArea = styled.div`
  max-width: calc(100% - 1px);
  width: calc(100% - 1px);
`

export const NoVirtualizer = <TData,>({
  'data-e2e': dataE2e = 'virtualizer',
  bottomOffset,
  isWindowScrollable = false,
  table,
  horizontalScrollingArea,
  setHorizontalScrollingAreaRef,
  children,
}: NoVirtualizerProps<TData>) => {
  if (isWindowScrollable) {
    return (
      <HorizontalScrollWrapper
        bottomOffset={bottomOffset}
        data-e2e={dataE2e}
        horizontalScrollingArea={horizontalScrollingArea}
        setHorizontalScrollingAreaRef={setHorizontalScrollingAreaRef}
        table={table}
      >
        {children}
      </HorizontalScrollWrapper>
    )
  }

  return (
    <HorizontalScrollingArea
      data-e2e={`${dataE2e}--scrolling-area`}
      ref={setHorizontalScrollingAreaRef}
    >
      {children}
    </HorizontalScrollingArea>
  )
}

export default NoVirtualizer
